import {
    ClosedDeviceModel,
    EligibilityRadio,
    RadioService,
} from '@sxm-de/dev-kits/microservices-sdk/types';
import { SxmTypeDevice } from '@sxm-de/dev-kits/web-sdk/types';

export function mapSmsDeviceToDevice(
    device: ClosedDeviceModel | RadioService | EligibilityRadio,
): SxmTypeDevice | null {
    if (!device) {
        return null;
    }
    /**
     * TODO:
     * map type from device when available
     */
    const type = 'car';
    const mappedDevice: SxmTypeDevice = {
        id: device.radioId ?? '',
        /**
         * TODO:
         * need to determine if radio ID is virtual
         */
        isVirtualId: false,
        type,
        radioIdLastFour: device.last4DigitsOfRadioId ?? '',
        nickname: '',
        vehicle: device.vehicleInfo
            ? {
                  make: device.vehicleInfo.make ?? '',
                  model: device.vehicleInfo.model ?? '',
                  year: device.vehicleInfo.year ?? '',
                  vin: device.vehicleInfo.vin ?? '',
                  yearMakeModel: [
                      device.vehicleInfo.year,
                      device.vehicleInfo.make,
                      device.vehicleInfo.model,
                  ]
                      .filter((part) => !!part)
                      .join(' '),
              }
            : null,
    };

    return mappedDevice;
}
